import React from 'react';
import BigImg from '@/assets/images/big-eximg.png';
import SmallImg from '@/assets/images/small-eximg.png';
import './index.less';
import { Button, Image } from 'antd';
import { ReactComponent as Vip } from '@/assets/icons/vip.svg';
import { useSelector } from 'react-redux';
import { requestDownload } from '../../../../api/apis';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import closeByupload from '@/assets/icons/ai/close-upload.svg';
import Cookies from 'js-cookie';
const DrawPage = (props) => {
  const reducerData = useSelector((state) => state.common);
  const { subscription } = reducerData;
  const [imgReady, setImgTeady] = useState(false);
  const { t } = useTranslation(['dynamicPhoto']);

  return (
    <div className='drawByphotos'>
      <div className='imgContainer'>
        <img
          alt=''
          className='bigImg'
          onLoad={() => {
            setImgTeady(true);
          }}
          src={props.src}
        />
        <div className='mask'></div>

        {imgReady && (
          <div
            className={`boxContent ${
              props.item.status === 2 || props.item.status === 0
                ? `lm-animate-slide-widthTrigger`
                : ''
            }`}
          >
            {/* 排队等待 */}
            {/* {props.item.status === 0 && (
            <div>
              <div className="createNav">{t('You are in line...')}</div>
              <div className="inside">
                <span className="activeNumber">{props.item.wait_front}</span>{t('xx people is waitting in front of you to generate image.')}
              </div>
            </div>
          )} */}
            {/* 处理中 */}
            {(props.item.status === 2 || props.item.status === 0) && (
              <div className='inside'>
                {t('Animating...')}
                <span className='activeNumber'>{props.item.progress}%</span>
              </div>
            )}
            {/* 失败 */}
            {props.item.status === 3 && (
              <div
                className='reflash'
                onClick={() => {
                  // retryDraw(item1)
                  props.retryInitwebsock();
                }}
              >
                <div className='reflashIcon'></div>
                <div className='subtitle'>
                  {t('Failed to generate, click to retry.')}
                </div>
              </div>
            )}
            <img
              alt=''
              className='closeBtn'
              src={closeByupload}
              onClick={() => {
                props.backToHome();
              }}
            />
            <div className='preImg'>Hitpaw</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DrawPage;
